import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
export function CountdownSection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-10 md:py-16 px-4 bg-white border-y-4 border-brand-orange" data-id="element-40">
      <div className="max-w-4xl mx-auto text-center" data-id="element-41">
        <h2 className="text-3xl md:text-4xl font-black text-brand-dark mb-6 md:mb-8" data-id="element-42">
          ⏰ EL PRECIO DE RELANZAMIENTO TERMINA EN:
        </h2>

        <div className={`flex justify-center gap-4 md:gap-8 mb-8 ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-43">
          <div className="flex flex-col items-center" data-id="element-44">
            <div className="bg-brand-dark text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px]" data-id="element-45">
              {formatTime(minutes)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-46">min</span>
          </div>
          <div className="text-5xl md:text-7xl font-black text-brand-dark self-start mt-2 md:mt-4" data-id="element-47">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-48">
            <div className={`text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px] ${isUrgent ? 'bg-red-600' : 'bg-brand-orange'}`} data-id="element-49">
              {formatTime(seconds)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-50">seg</span>
          </div>
        </div>

        <p className="text-2xl font-bold text-red-600 mb-10" data-id="element-51">
          Después sube y no vuelve a bajar.
        </p>

        <div className="max-w-2xl mx-auto bg-gray-100 p-6 rounded-2xl mb-10" data-id="element-52">
          <div className="flex justify-between text-sm font-bold text-gray-700 mb-2" data-id="element-53">
            <span data-id="element-54">🔴 Cupos al precio de relanzamiento</span>
            <span data-id="element-55">Quedan pocos</span>
          </div>
          <div className="w-full bg-gray-300 rounded-full h-4 mb-2 overflow-hidden" data-id="element-56">
            <div className="bg-red-600 h-4 rounded-full" style={{
            width: '68%'
          }} data-id="element-57"></div>
          </div>
          <div className="text-right text-sm font-bold text-red-600" data-id="element-58">
            68% de los cupos tomados
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-59">
          <CTAButton text="→ ASEGURAR MI PRECIO AHORA" href="https://checkout.guiadigital360.online/cart/44005388255301:1" isLink={true} data-id="element-60" />
        </div>
      </div>
    </section>;
}